import { ApplicationModule } from '@philips-internal/oswald-ui-foundation';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

interface ApplicationModuleApp extends ApplicationModule {
  preventNavigation: boolean,
}

export enum ApplicationModulesIds {
  PATIENT_ROOT = 'patient-root',
  EXAMS = 'exams',
  DASHBOARD = 'dashboard',
  PROFILE = 'profile',
  APPOINTMENTS = 'appointments',
  MY_CHART = 'my_chart',
  TASKS = 'tasks',
  MATERIAL_EDUCATIONAL = 'educational_material',
  ONLINE_PAYMENTS = 'online_payments',
  ALLERGIES = 'allergies',
  MEDICINE = 'medicine'
}

/**
 * The modules id must match the enum name of PatientModules.java and in lowercase
 * name: description or expression for display in ApplicationBar.
 */
export const ApplicationModules = new Map<ApplicationModulesIds, ApplicationModuleApp> ([
  [
    ApplicationModulesIds.APPOINTMENTS,
    {
      closeable: true,
      entry: ApplicationModulesIds.APPOINTMENTS,
      id: ApplicationModulesIds.APPOINTMENTS,
      name: 'patient.home.tab.appointments',
      preventNavigation: true,
      route: APPLICATION_ROUTES.APPOINTMENTS,
    }
  ],
  [
    ApplicationModulesIds.MATERIAL_EDUCATIONAL,
    {
      closeable: true,
      entry: ApplicationModulesIds.MATERIAL_EDUCATIONAL,
      id: ApplicationModulesIds.MATERIAL_EDUCATIONAL,
      name: 'patient.material.education.title',
      preventNavigation: true,
      route: APPLICATION_ROUTES.MATERIAL_EDUCATIONAL,
    }
  ],
  [
    ApplicationModulesIds.PROFILE,
    {
      closeable: true,
      entry: ApplicationModulesIds.PROFILE,
      id: ApplicationModulesIds.PROFILE,
      name: 'patient.profile',
      preventNavigation: true,
      route: APPLICATION_ROUTES.PROFILE,
    }
  ],
  [
    ApplicationModulesIds.DASHBOARD,
    {
      closeable: false,
      entry: ApplicationModulesIds.DASHBOARD,
      id: ApplicationModulesIds.DASHBOARD,
      name: 'patient.home.tab.home',
      preventNavigation: true,
      route: APPLICATION_ROUTES.HOME_DASHBOARD,
    }
  ],
  [
    ApplicationModulesIds.EXAMS,
    {
      closeable: true,
      entry: ApplicationModulesIds.EXAMS,
      id: ApplicationModulesIds.EXAMS,
      name: 'patient.home.tab.examresult',
      preventNavigation: true,
      route: APPLICATION_ROUTES.EXAMS,
    }
  ],
  [
    ApplicationModulesIds.PATIENT_ROOT,
    {
      entry: ApplicationModulesIds.PATIENT_ROOT,
      id: ApplicationModulesIds.PATIENT_ROOT,
      name: 'patient-root',
      preventNavigation: false,
      route: APPLICATION_ROUTES.PATIENT_ROOT,
    }
  ],
  [
    ApplicationModulesIds.MY_CHART,
    {
      closeable: true,
      entry: ApplicationModulesIds.MY_CHART,
      id: ApplicationModulesIds.MY_CHART,
      name: 'patient.home.tab.my-chart',
      preventNavigation: true,
      route: APPLICATION_ROUTES.MY_CHART,
    }
  ],
  [
    ApplicationModulesIds.ONLINE_PAYMENTS,
    {
      closeable: true,
      entry: ApplicationModulesIds.ONLINE_PAYMENTS,
      id: ApplicationModulesIds.ONLINE_PAYMENTS,
      name: 'patient.home.tab.payments',
      preventNavigation: true,
      route: APPLICATION_ROUTES.ONLINE_PAYMENTS,
    }
  ],
  [
    ApplicationModulesIds.ALLERGIES,
    {
      closeable: true,
      entry: ApplicationModulesIds.ALLERGIES,
      id: ApplicationModulesIds.ALLERGIES,
      name: 'patient.label.allergies',
      preventNavigation: true,
      route: APPLICATION_ROUTES.MY_CHART_ALLERGIES,
    }
  ],
  [
    ApplicationModulesIds.TASKS,
    {
      closeable: true,
      entry: ApplicationModulesIds.TASKS,
      id: ApplicationModulesIds.TASKS,
      name: 'tws.patient.tasks',
      preventNavigation: true,
      route: APPLICATION_ROUTES.TASKS,
    }
  ],
  [
    ApplicationModulesIds.MEDICINE,
    {
      closeable: true,
      entry: ApplicationModulesIds.MEDICINE,
      id: ApplicationModulesIds.MEDICINE,
      name: 'patient.label.medicines-in-use',
      preventNavigation: true,
      route: APPLICATION_ROUTES.MY_CHART_MEDICINES_IN_USE,
    }
  ],
]);
